
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oranges/[bookId]",
      function () {
        return require("private-next-pages/oranges/[bookId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oranges/[bookId]"])
      });
    }
  